import { PublicAppError } from "./errors";

export const REQUEST_TIMEOUT_MS = 8_000;

export async function withRequestSignal<T>(
  parentSignal: AbortSignal | undefined,
  task: (signal: AbortSignal) => Promise<T>,
  timeoutMs = REQUEST_TIMEOUT_MS,
): Promise<T> {
  const controller = new AbortController();
  const forwardAbort = () => controller.abort(parentSignal?.reason);
  parentSignal?.addEventListener("abort", forwardAbort, { once: true });
  const timer = window.setTimeout(() => controller.abort("timeout"), timeoutMs);
  try {
    return await task(controller.signal);
  } catch (error: unknown) {
    if (controller.signal.aborted) {
      throw new PublicAppError(
        parentSignal?.aborted ? "request_cancelled" : "request_timeout",
        parentSignal?.aborted
          ? "A operação foi cancelada."
          : "A operação demorou mais que o esperado. Tente novamente.",
      );
    }
    throw error;
  } finally {
    window.clearTimeout(timer);
    parentSignal?.removeEventListener("abort", forwardAbort);
  }
}
